import React, { useContext } from "react";
import { QuizContext } from "../../App";
import TextMistake from "../text/TextMistake";

const ButtonConfirmQuizTable = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;
  const colorHeaders = quizContext.state.checkHeaders && theme === "dark"
    ? "#03f603"
    : quizContext.state.checkHeaders && theme === "light"
      ? "green"
      : "red";
  const colorVaules = quizContext.state.checkVaules && theme === "dark"
  ? "#03f603"
  : quizContext.state.checkVaules && theme === "light"
    ? "green"
    : "red";
  const colorTitle = quizContext.state.checkQuizTitle && theme === "dark"
  ? "#03f603"
  : quizContext.state.checkQuizTitle && theme === "light"
    ? "green"
    : "red";

  return (
    <>
      <div>
        <span style={{ fontWeight: "600" }}>
          ШАГ 3:</span> когда заполните таблицу (<span style={{ color: `${colorHeaders}`, fontWeight: "600" }}>заголовки столбцов</span> и <span style={{ color: `${colorVaules}`, fontWeight: "600" }}>значения ячеек</span>) и дадите квизу <span style={{ color: `${colorTitle}`, fontWeight: "600" }}>название</span>, отправьте его на проверку
      </div>
      {quizContext.state.errorMessage === "table mistake"
        && <TextMistake />
      }
      <div style={{ textAlign: "center", marginTop: "5px" }}></div>
      <div style={{
        textAlign: "center",
        marginTop: "5px"
      }}
      >
        {quizContext.state.alertStatus === "changes made"
          ? <button
            className={`${theme}-main-btn`}
            onClick={() => quizContext.dispatch({
              type: "confirmQuizTable"
            })}
          >
            ПРОВЕРИТЬ
          </button>
          : <button className={`${theme}-main-btn-inactive`}>
            <span style={{ cursor: "crosshair" }}>
              ПРОВЕРИТЬ
            </span>
          </button>
        }
      </div>
    </>
  )
}

export default ButtonConfirmQuizTable